const header = document.querySelector(".header");
const hero = document.querySelector(".hero");

if (header && hero) {
    const headerButton = document.querySelector(".js-header-button");
    headerButton.classList.add('button-white')
}